import { useState, useEffect } from "react";
import SearchContactId from "./SearchContactId";
import data from "./database.json";
import { get, post } from "aws-amplify/data";

// Mapping URLs to numbers as in Confluence
const urlToNumberMapping: Record<number, string> = {
  501: "https://sit-gateway.optus.com.au",
  502: "https://sit2-gateway.optus.com.au",
  541: "https://sit4-gateway.optus.com.au",
  551: "https://sit5-gateway.optus.com.au",
};

interface TestingEnvironmentProps {
  searchId: number;
}

export default function TestingEnvironment({
  searchId,
}: TestingEnvironmentProps) {
  const [userAttributes, setUserAttributes] = useState<any>(null);
  const [isTester, setIsTester] = useState<boolean>(false);
  const [selectedEnvironment, setSelectedEnvironment] = useState<
    string | undefined
  >("default");

  // Function to call the API to get user attributes
  const getUserAttributes = async (contactId: number) => {
    try {
      const res = await get({
        apiName: "TEST_BASE_URL",
        path: `pp/qa/user/userAttributes/get/${contactId}`,
        options: {},
      }).response;
      const responsePayload = (await res.body.json()) as any;
      setUserAttributes(responsePayload);
      setIsTester(responsePayload?.isTester || false);
      console.log("User Attributes:", responsePayload);
    } catch (error) {
      console.error("Error fetching user attributes:", error);
      setUserAttributes(null);
    }
  };

  // Function to update user attributes
  const updateUserAttributes = async ({
    contactId,
    isTester,
    environmentNumber,
  }: {
    contactId: number;
    isTester: boolean;
    environmentNumber: number | undefined; // Allow undefined
  }) => {
    // If environmentNumber is undefined, handle it with a default value
    const optusApigeeEndpoint =
      environmentNumber !== undefined
        ? urlToNumberMapping[environmentNumber]
        : "";

    if (environmentNumber === undefined) {
    } else if (!optusApigeeEndpoint) {
      console.error(`Invalid environment number: ${environmentNumber}`);
      return;
    }

    const apiName = "TEST_BASE_URL";
    const path = `pp/qa/user/userAttributes/update/${contactId}`;
    const myInit = {
      body: {
        optusApigeeEndpoint, // Pass the empty string or default behavior if undefined
        isTester,
      },
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await post({
        apiName,
        path,
        options: myInit,
      }).response;
      const res = (await response.body.json()) as any;
      console.log("API call successful:", res);
      return res;
    } catch (error) {
      console.error("Error updating user attributes:", error);
    }
  };

  // whenever we get userattributes, the state for user attirbutes is changed !!!
  // this is the purpose of this hook - basicaly an infinite setuserattributes

  useEffect(() => {
    const result = SearchContactId(data, searchId);
    console.log(result);
    getUserAttributes(searchId);
  }, [searchId]);

  // whenever the above hook runs, this then runs
  // this maps the endpoint to a number (w3schools pasted)
  // default if no number exists for the endpoint
  // updates

  useEffect(() => {
    const environmentNumber =
      userAttributes && userAttributes.optusApigeeEndpoint
        ? Object.keys(urlToNumberMapping).find(
            (key) =>
              urlToNumberMapping[Number(key)] ===
              userAttributes.optusApigeeEndpoint
          ) || "default"
        : "default";

    setSelectedEnvironment(environmentNumber.toString());
  }, [userAttributes]);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsTester(e.target.checked);
  };

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    // If "default" is selected, set selectedEnvironment to undefined
    setSelectedEnvironment(
      e.target.value === "default" ? undefined : e.target.value
    );
  };

  const handleUpdate = async () => {
    const environmentNumber = selectedEnvironment
      ? Number(selectedEnvironment)
      : undefined;

    console.log("Calling API with:", {
      contactId: searchId,
      isTester,
      environmentNumber,
    });

    try {
      const response = await updateUserAttributes({
        contactId: searchId,
        isTester,
        environmentNumber,
      });
      console.log("Update successful:", response);
    } catch (error) {
      console.error("Error in handleUpdate:", error);
    }
  };

  return (
    <div>
      <div className="tester-checkbox">
        <h2>isTester</h2>
        <input
          type="checkbox"
          checked={isTester}
          onChange={handleCheckboxChange}
        />
      </div>
      <div className="Testing-Environment">
        <h2>Testing Environment</h2>
        <select value={selectedEnvironment} onChange={handleDropdownChange}>
          <option value="501">501</option>
          <option value="502">502</option>
          <option value="541">541</option>
          <option value="551">551</option>
          <option value="default">default</option>
        </select>
      </div>
      <div>
        <button onClick={handleUpdate}>Update Test User</button>
      </div>
    </div>
  );
}
